const initialState = {
    id: '',
    email: '',
    administrator: false
};

export default initialState;
